import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Ecosystem from "../pages/ecosystem/page";
import KnowledgeHub from "../pages/knowledge/page";
import OmcTenders from "../pages/tenders/page";
import Contact from "../pages/contact/page";
import Represent from "../pages/represent/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/ecosystem",
    element: <Ecosystem />,
  },
  {
    path: "/knowledge",
    element: <KnowledgeHub />,
  },
  {
    path: "/tenders",
    element: <OmcTenders />,
  },

  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/represent",
    element: <Represent />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
